import Header from "./Header";
import Customizer from "./Customizer";
import CarSwap from "./CarSwapUI";
import OrbitMode from "./OrbitModeUI/OrbitModeUI";
import "../../styles/styles.css";
import useTransitionStore from "../../state/transitions";
import ModelNameFlipper from "../webgl/Car/CarFlip/ModelNameFlipper";
import { ScrollContainer } from "./ScrollContainer";
import { AnimatePresence, MotionConfig } from "framer-motion";
import Powertrain from "./Customizer/PowertrainUI";

export default function UI() {
  const DisplayMode = useTransitionStore((s) => s.DisplayMode);

  return (
    <>
      <Header />
      <Customizer />
      <CarSwap />
      <OrbitMode />
      <Powertrain />
      {DisplayMode === "flipper" && <ScrollContainer />}
      <MotionConfig transition={{ duration: 1 }}>
        <AnimatePresence>
          {DisplayMode === "flipper" && (
            <ModelNameFlipper key="model-flipper-title" />
          )}
        </AnimatePresence>
      </MotionConfig>
    </>
  );
}
